// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

// ----------------------------------------------------------------------

// const icon = (name) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

const icon = (name) => (
  <img alt={name} src={`/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  catering: icon("ic_round_food_bank"),
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  coupon: icon("ic_coupon"),
  notification: icon("ic_notification"),
  profile: icon("ic_profile"),
  pages: icon("ic_pages"),
  blogs: icon("ic_blogs"),
  settings: icon("ic_settings"),
  tripHour: icon("ic_trip_hr"),
  vehicle: icon("ic_vehicle"),
  reports: icon("ic_reports"),
  contacts: icon("ic_contacts"),
  testimonials: icon("ic_testimonials"),
  school: icon("ic_school"),
  dress: icon("ic_dress"),
  size: icon("ic_size"),
  category: icon("ic_category"),
  house: icon("ic_house"),
  product: icon("ic_product"),
  orders: icon("ic_order"),
  gallery: icon("ic_gallery"),
  notice: icon("ic_notice"),
};

const navConfig = [
  // analytics
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      // {
      //   title: "Dashboard",
      //   path: PATH_DASHBOARD.dashboard,
      //   icon: ICONS.dashboard,
      // },
      {
        title: "Profile",
        path: PATH_DASHBOARD.rider_profile,
        icon: ICONS.profile,
      },
      // { title: 'Notifications', path: PATH_DASHBOARD.notification, icon: ICONS.notification },
    ],
  },

  // TODO: order management
  {
    subheader: "Order Management",
    items: [
      {
        title: "Orders Status",
        path: PATH_DASHBOARD.crmorder_rider.list,
        icon: ICONS.orders,
      },
    ],
  },
];

export default navConfig;
